<template>
  <div
    class="tooltip"
    @mouseover="changeDisplay($event, true)"
    @mouseleave="changeDisplay($event, false)"
  >
    <slot></slot>
    <div :style="tlTriangle"></div>
    <div :style="tl">{{ message }}</div>
  </div>
</template>
<script>
export default {
  name: 'Tooltip',
  props: {
    message: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      tl: {
        display: 'none',
        position: 'fixed',
        color: '#fff',
        background: '#363636',
        padding: '8px',
        'font-size': '14px',
        'border-radius': '5px',
        'z-index': '30000',
        'white-space': 'pre-wrap',
      },
      tlTriangle: {
        display: 'none',
        position: 'fixed',
        top: '-20px',
        left: '5px',
        border: '15px solid transparent',
        'border-top': '15px solid #363636',
        transform: 'rotateZ(180deg)',
      },
    }
  },
  methods: {
    changeDisplay(e, flg) {
      if (flg) {
        this.tl.display = 'block'
        this.tlTriangle.display = 'block'
        this.tl.top = Number(e.pageY + 24) + 'px'
        this.tl.left = Number(e.pageX - 16) + 'px'
        this.tlTriangle.top = Number(e.pageY + 2) + 'px'
        this.tlTriangle.left = Number(e.pageX - 4) + 'px'
      } else {
        this.tl.display = 'none'
        this.tlTriangle.display = 'none'
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.tooltip {
  position: relative;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/atoms/tooltips/Tooltip.vue